export type AppEnv = 'local' | 'staging' | 'production';

export function appEnv(): AppEnv {
  const host = (window.location.hostname || '').toLowerCase();

  if (
    host === 'localhost' || host === '127.0.0.1' || host === '::1' ||
    host.endsWith('.local') ||
    /^(10|127)\./.test(host) || /^192\.168\./.test(host) ||
    /^172\.(1[6-9]|2\d|3[01])\./.test(host)
  ) { return 'local'; }

  if (/(^|[.-])(staging|stg|uat|test|dev)([.-]|$)/.test(host)) { return 'staging'; }

  return 'production';
}

export function appEnvLabel(): string {
  const env = appEnv();
  return env === 'local' ? 'Local' : env === 'staging' ? 'Staging' : '';
}
